{
  "version": 1,
  "symbol": "asset.game.TakeAimAsset",
  "sourceCharacterId": 263,
  "evidence": "Exact original TakeAimAsset vector paths; later archive reference corroborates the translucent character-front aim in the saved 2009 controls screenshot.",
  "playerOffset": {
    "x": -30,
    "y": -20
  },
  "sourceCode": "research/source-inspection/aim-projectile-audit/GameLocalPlayer.as:102-106,519-521",
  "referenceScreenshot": "assets/reference/official/images/2009_28-3703_reference_00.jpg",
  "assets": {
    "background": {
      "path": "/game/ui/aim/background/frame-00.svg",
      "frames": [
        "/game/ui/aim/background/frame-00.svg"
      ],
      "width": 96,
      "height": 93,
      "anchor": {
        "x": 50,
        "y": 57
      },
      "frameRate": 25,
      "sha256": [
        "f42a9b09bd7166964cf582e4c1a81e19f866b81cbdfece26acd2564a4c5ee887"
      ],
      "sourceCharacterId": 259,
      "sourcePath": "assets/candidate/original/ddtank-ii/ui/portugal/swf/gameiii.swf",
      "sourceSha256": "5b706f2c0f26bd5f0a6621c0da809352f0272cfea789a1fa595cb9fe5b501be7",
      "derivation": "Exact archived SWF ShapeRecord paths, fill colors, gradients, depth, MATRIX and ShowFrame order converted to SVG; no redraw or ActionScript execution",
      "candidateConfidence": "Exact original source symbol, later archived client candidate; geometry is not independently dated to 2009",
      "placement": {
        "x": 0.0,
        "y": 0.0
      }
    },
    "hand": {
      "path": "/game/ui/aim/hand/frame-00.svg",
      "frames": [
        "/game/ui/aim/hand/frame-00.svg"
      ],
      "width": 48,
      "height": 4,
      "anchor": {
        "x": 61,
        "y": 2
      },
      "frameRate": 25,
      "sha256": [
        "a20dcdc0894cbe93eb6f195d9e16029165dc01fe83bde7760b866d973bd283d4"
      ],
      "sourceCharacterId": 262,
      "sourcePath": "assets/candidate/original/ddtank-ii/ui/portugal/swf/gameiii.swf",
      "sourceSha256": "5b706f2c0f26bd5f0a6621c0da809352f0272cfea789a1fa595cb9fe5b501be7",
      "derivation": "Exact archived SWF ShapeRecord paths, fill colors, gradients, depth, MATRIX and ShowFrame order converted to SVG; no redraw or ActionScript execution",
      "candidateConfidence": "Exact original source symbol, later archived client candidate; geometry is not independently dated to 2009",
      "placement": {
        "x": 0.35,
        "y": 0.25
      }
    }
  },
  "warnings": []
}
